import { ANNUAL_PROGRAMS_CHOOSE_CATEGORY_FRAGMENT_ID } from '@/_i18n/section-params'

export type NavPathActiveOpts = {
	exact?: boolean
}

/**
 * Hash fragment match for nav highlighting. Hub „Všetky ročné programy“ uses `chooseProgramCategory`
 * id while `/rocne-programy` bez fragmentu remains canonical — treat both as that link.
 */
export function routeHashMatchesLinkFragment(
	routeHashWithoutLeadingHash: string,
	linkHashFragment: string
): boolean {
	if (linkHashFragment === ANNUAL_PROGRAMS_CHOOSE_CATEGORY_FRAGMENT_ID) {
		return (
			routeHashWithoutLeadingHash === '' ||
			routeHashWithoutLeadingHash === linkHashFragment
		)
	}
	return routeHashWithoutLeadingHash === linkHashFragment
}

/**
 * Whether the current route matches a nav link `to` value (supports `#fragment` and exact hub paths).
 */
function stripSlashes(p: string) {
	return p.replace(/^\//, '').split('?')[0].replace(/\/+$/, '')
}

export function isNavPathActive(
	linkPath: string,
	pathWithoutLocale: string,
	locationHash: string,
	opts?: NavPathActiveOpts
): boolean {
	const [pathPart, hashFromLink] = linkPath.split('#')
	const linkPathNorm = stripSlashes(pathPart)
	const pathNorm = stripSlashes(pathWithoutLocale)
	const currentHash = locationHash

	if (hashFromLink) {
		if (!pathNorm) return linkPathNorm === '' || linkPath === '/'
		if (!linkPathNorm) return pathNorm === ''
		const routeHashOnly = currentHash.replace(/^#/, '')
		const hashOk = routeHashMatchesLinkFragment(routeHashOnly, hashFromLink)
		return pathNorm === linkPathNorm && hashOk
	}

	if (!pathNorm) return linkPathNorm === '' || linkPath === '/'
	if (!linkPathNorm) return pathNorm === ''

	if (opts?.exact) {
		const hasFragment = Boolean(currentHash.replace(/^#/, ''))
		return pathNorm === linkPathNorm && !hasFragment
	}

	return pathNorm === linkPathNorm || pathNorm.startsWith(`${linkPathNorm}/`)
}
